import _ from 'lodash';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSelect, { MultiSelectOption } from '../../../core/modules/common/components/MultiSelect';
import OPERATORS from '../constants/operators';
import ColumnFilter from './ColumnFilter';
import DayPickerInput from './DayPickerInput';
import DATE_FORMATS from '../constants/dateFormats';

const isValid = (operator, fromDate, toDate, multiSelectValues) => {
  if (multiSelectValues && multiSelectValues.length > 0) {
    return true;
  }

  if (!fromDate) {
    return false;
  }

  if (operator === OPERATORS.BETWEEN) {
    if (!toDate) {
      return false;
    }

    const momentToDate = moment(toDate);
    return moment(fromDate).isBefore(momentToDate);
  }

  return true;
};

const initialCurrent = {
  operator: OPERATORS.EQUALS,
  fromDate: undefined,
  toDate: undefined,
  valid: false,
};

class DateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = props => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return new MultiSelectOption(null, '(Blank)');
      }
      if ((Array.isArray(value) && value.length)) {
        return value.map(v => new MultiSelectOption(moment(v).format(DATE_FORMATS.date)));
      }

      return new MultiSelectOption(moment(value).format(DATE_FORMATS.date));
    })
    .flatten()
    .uniqBy('value')
    .value()
    .sort((a, b) => ((b.value === null ||
      moment(a.label)
        .isAfter(moment(b.label))) ? 1 : -1));

  render() {
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                value={current.multiSelectValues}
                onChange={value => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: isValid(current.operator, current.fromDate, current.toDate, value),
                  type: this.props.column.type,
                })}
                options={this.state.multiSelectOptions}
              />
            </div>
            <div className="advanced-filter__fields">
              <RadioButtonGroup
                onChange={(event, operator) => {
                  setCurrent({ ...current, operator });
                }}
                name="dateFilter"
                valueSelected={current.operator}
              >
                <RadioButton
                  value={OPERATORS.EQUALS}
                  label={<FormattedMessage id="filter-component.label.equals" />}
                />
                <RadioButton
                  value={OPERATORS.GREATER_THAN}
                  label={<FormattedMessage id="filter-component.label.greater-than" />}
                />
                <RadioButton
                  value={OPERATORS.GREATER_THAN_EQUAL_TO}
                  label={<FormattedMessage id="filter-component.label.greater-than-equal-to" />}
                />
                <RadioButton
                  value={OPERATORS.SMALLER_THAN}
                  label={<FormattedMessage id="filter-component.label.smaller-than" />}
                />
                <RadioButton
                  value={OPERATORS.SMALLER_THAN_EQUAL_TO}
                  label={<FormattedMessage id="filter-component.label.smaller-than-equal-to" />}
                />
                <RadioButton
                  value={OPERATORS.BETWEEN}
                  label={<FormattedMessage id="filter-component.label.between" />}
                />
              </RadioButtonGroup>
            </div>

            <div className="advanced-filter__fields">
              <DayPickerInput
                value={current.fromDate}
                type={this.props.column.type}
                onChange={(fromDate) => {
                  const valid = isValid(
                    current.operator,
                    fromDate,
                    current.toDate,
                    current.multiSelectValues,
                  );
                  setCurrent({
                    ...current,
                    fromDate,
                    valid,
                  });
                }}
              />
              {current.operator === OPERATORS.BETWEEN &&
              <DayPickerInput
                value={current.toDate}
                type={this.props.column.type}
                onChange={(toDate) => {
                  const valid = isValid(
                    current.operator,
                    current.fromDate,
                    toDate,
                    current.multiSelectValues,
                  );
                  setCurrent({
                    ...current,
                    toDate,
                    valid,
                  });
                }}
              />
              }
            </div>
          </div>
        )}
      />

    );
  }
}

export default DateFilter;
DateFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  column: PropTypes.shape({
    Cell: PropTypes.func,
    type: PropTypes.string,
  }),
};
